import { paths } from "@/router/paths";
import { INavItem } from "@/types/routing";
import { MessageSquare, AreaChart, Users, Settings } from "lucide-react";

export const topNavItems: Array<INavItem> = [
  {
    namePath: "menu.conversations",
    path: paths.app.conversations,
    icon: <MessageSquare />,
  },
  {
    namePath: "menu.customers",
    path: paths.app.customers,
    icon: <Users />,
  },
  {
    namePath: "menu.analytics",
    path: paths.app.analytics,
    icon: <AreaChart />,
  },
];

export const bottomNavItems: Array<INavItem> = [
  {
    namePath: "menu.settings",
    path: paths.settings.index,
    icon: <Settings />,
  },
];

export const navItems: Array<INavItem> = [...topNavItems, ...bottomNavItems];
